module.exports = __webpack_public_path__ + "media/images/google-play-52e9cdcf565cf1a52e4a382cef398283.svg";